var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMeasure = function SvgMeasure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F1563C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.674 16.058L8.317 5.701a.259.259 0 00-.442.183v10.357a.26.26 0 00.259.259H18.49a.26.26 0 00.183-.442zm-5.122-1.79a.26.26 0 01-.24.16h-2.589a.259.259 0 01-.259-.258v-2.59a.26.26 0 01.442-.183l2.59 2.59a.259.259 0 01.056.282z"
  }))));
};
export default SvgMeasure;